<template>
    <div class="body">
        <div class="content">
            <frame1 v-if="frame == 1"/>
            <frame2 v-show="frame == 2"/>
            <frame3 v-show="frame == 3"/>
            <frame4 v-show="frame == 4"/>
            <frame5 v-show="frame == 5"/>
            <frame612 v-if="frame == 6 || frame == 12" :frame_no="frame"/>
            <frame7 v-if="frame == 7"/>
            <frame8 v-show="frame == 8"/>
            <frame9 v-show="frame == 9"/>
            <frame10 v-show="frame == 10"/>
            <frame11 v-show="frame == 11"/>
            <frame13 v-if="frame == 13"/>
            <frame14 v-if="frame == 14"/>
            <frame15 v-if="frame == 15"/>
        </div>
        <div class="footer">
          <button class="btn" @click="nextFrame()">{{ button_start }}</button>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import {
  Frame1,
  Frame2,
  Frame3,
  Frame4,
  Frame5,
  Frame612,
  Frame7,
  Frame8,
  Frame9,
  Frame10,
  Frame11,
  Frame13,
  Frame14,
  Frame15
} from '@/components/frames'

export default {
  name: 'my-content',
  components: {
    Frame1,
    Frame2,
    Frame3,
    Frame4,
    Frame5,
    Frame612,
    Frame7,
    Frame8,
    Frame9,
    Frame10,
    Frame11,
    Frame13,
    Frame14,
    Frame15
  },
  data () {
    return {
      frame: 1,
      button_start: 'START'
    }
  },
  methods: {
    ...mapActions([
      'asyncData',
      'asyncRawData'
    ]),
    nextFrame () {
      if (this.frame === 6 || this.frame === 12) {
        if (this.frame === 6) {
          this.asyncData({
            model: 'problem1',
            data: this.range
          })
        } else {
          this.asyncData({
            model: 'problem2',
            data: this.range
          })
        }
      }
      this.frame++
      var self = this
      if (this.frame < 15) {
        setTimeout(function(){ 
          self.asyncData({
            model: 'progress',
            data: self.progress + 7.143
          })
        }, 0)  
        if (this.frame > 1) {
          this.button_start = 'NEXT'
        } else {
          this.button_start = 'START'
        }
      } else if (this.frame === 15) {
        setTimeout(function(){ 
          self.asyncData({
            model: 'progress',
            data: 100
          })
        }, 0) 
        setTimeout(function(){ 
          self.asyncRawData({
            model: 'raw',
            data: {
              problem1: parseInt(self.problem1),
              problem2: parseInt(self.problem2)
            }
          }).then(function() {
              self.$session.set('raw', self.raw)
          })
        }, 0) 
        this.button_start = 'TRY AGAIN'
      } else {
        this.frame = 1
        this.button_start = 'START'
        this.asyncData({
          model: 'progress',
          data: 0
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getData'
    ]),
    progress () {
      return this.getData('progress')
    },
    range () {
      return this.getData('range')
    },
    raw () {
      return this.getData('raw')
    },
    problem1 () {
      return this.getData('problem1')
    },
    problem2 () {
      return this.getData('problem2')
    }
  }
}
</script>
